import { Button, Tooltip } from '@mui/material';
import Link from 'Components/Shared/Link';
import useTranslate from 'Hooks/useTranslate';
import { TProfileManagerMessagesKeys } from 'Languages/TProfileManagerMessages';

export interface MfaUnavailableOrInitializeProps {
  readonly canUseMfa: boolean;
  readonly isCurrentUser: boolean;
  readonly initializeLabel: TProfileManagerMessagesKeys;
  readonly loginType: string;
  readonly isBlockedByOrganization: boolean;
}

function MfaUnavailableOrInitialize({
  canUseMfa,
  isCurrentUser,
  initializeLabel,
  loginType,
  isBlockedByOrganization
}: MfaUnavailableOrInitializeProps): JSX.Element | null {
  const ts = useTranslate();

  if (!canUseMfa || !isCurrentUser || isBlockedByOrganization) {
    let mfaUnavailableMessage: string;
    switch (true) {
      case isBlockedByOrganization:
        mfaUnavailableMessage = ts('page.userProfile.security.mfa.initializeNotAllowed');
        break;
      case isCurrentUser:
        mfaUnavailableMessage = ts('page.userProfile.security.mfa.cannotUseMfa');
        break;
      default:
        mfaUnavailableMessage = ts('page.userProfile.security.mfa.notConnectedUserMfa');
        break;
    }
    return (
      <Tooltip title={mfaUnavailableMessage}>
        <Button color="info" sx={{ cursor: 'not-allowed' }}>
          {ts(initializeLabel)}
        </Button>
      </Tooltip>
    );
  }

  const redirectUrl = encodeURIComponent(globalThis.location.href);
  const loginUrl =
    `${AppSettings.API_ENDPOINT_URI}` +
    `pmsession/login?logintype=${loginType}&returnUrl=${encodeURIComponent(
      `/end_login?returnUrl=${redirectUrl}`
    )}`;
  return (
    <Link href={loginUrl}>
      {ts(initializeLabel)}
    </Link>
  );
}

export default MfaUnavailableOrInitialize;
